import { adminCall, adminGet } from '../../api/adminCall';
import { apiRequest } from '../../../api/client';

export async function createAdminInvite({ email, role }) {
  const data = await adminCall('/api/admin/invites', { email, role });
  if (!data?.success) {
    throw new Error(data?.message || 'Failed to create invite');
  }
  return data;
}

export async function listAdminInvites({ status = 'pending' } = {}) {
  const qs = new URLSearchParams();
  if (status) qs.set('status', status);
  const data = await adminGet(`/api/admin/invites?${qs.toString()}`);
  return data?.invites || [];
}

export async function resendAdminInvite({ token }) {
  const data = await adminCall(`/api/admin/invites/${encodeURIComponent(token)}/resend`);
  if (!data?.success) {
    throw new Error(data?.message || 'Failed to resend invite');
  }
  return data;
}

export async function cancelAdminInvite({ token }) {
  const data = await adminCall(`/api/admin/invites/${encodeURIComponent(token)}/cancel`);
  if (!data?.success) {
    throw new Error(data?.message || 'Failed to cancel invite');
  }
  return data;
}

export async function getAdminInviteByToken(token) {
  return apiRequest(`/api/public/admin-invites/${encodeURIComponent(token)}`);
}

export async function acceptAdminInvite({ token, firstName, lastName, password }) {
  const data = await apiRequest(`/api/admin/invites/${encodeURIComponent(token)}/accept`, {
    method: 'POST',
    body: { firstName, lastName, password },
  });
  if (!data?.success) {
    throw new Error(data?.message || 'Failed to accept invite');
  }
  if (data?.token) {
    const { setAdminSessionToken } = await import('../../../api/authToken');
    const { notifyAdminAuthChanged } = await import('../../admin-auth/adminAppAuth');
    setAdminSessionToken(data.token);
    notifyAdminAuthChanged();
  }
  return data;
}
